// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__TGg-F","select":"UserProfile_select__R9JAm","logout":"UserProfile_logout__NXq67"};